<template>
  <q-card flat bordered >
    <q-card-section class="q-pa-sm bg-primary">
      <div class="text-subtitle1 text-bold text-white">
        <q-icon name="schedule" style="font-size: 25px; padding-right: 0.1rem" />
       Time Zones
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <div>
        <img
          class="q-mt-sm"
          :src="require('../../assets/united-states-time-zone-map.jpg')"
        />
        <div class="row justify-around">
          <span>{{ pstTime }}</span>
          <span>{{ mstTime }}</span>
          <span>{{ cstTime }}</span>
          <span>{{ estTime }}</span>
        </div>
      </div>
    </q-card-section>
  </q-card>

</template>

<script>
import {
  formatEST,
  formatCST,
  formatMST,
  formatPST
} from '@server/lib/date-format';

export default {
  data() {
    return {
      assetDomain: window.ASSET_DOMAIN,
      estTime: '',
      cstTime: '',
      mstTime: '',
      pstTime: ''
    };
  },
  created() {
    this.estTime = formatEST(new Date(), 'HH:mm a');
    this.cstTime = formatCST(new Date(), 'HH:mm a');
    this.mstTime = formatMST(new Date(), 'HH:mm a');
    this.pstTime = formatPST(new Date(), 'HH:mm a');
  }
};
</script>

<style></style>
